// routes/_app.membership.credit-packs.tsx
import { MembershipPageTab } from '~/pages/Membership/constants'
import { createMembershipRouteHandle } from '~/pages/Membership/route-utils'

export const handle = createMembershipRouteHandle({
  name: 'membership/credit-packs',
  track: { scene: 'credit-packs' },
  hideMembershipBanner: true,
  showCreditPill: true,
  pageTab: MembershipPageTab.packs,
})

export function loader() {
  return null
}

export default function Page() {
  return null
}
